import { render, staticRenderFns } from "./sectionTransactionLaunched.vue?vue&type=template&id=18bec4bf"
import script from "./sectionTransactionLaunched.vue?vue&type=script&lang=js"
export * from "./sectionTransactionLaunched.vue?vue&type=script&lang=js"
import style0 from "./sectionTransactionLaunched.vue?vue&type=style&index=0&id=18bec4bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports